<template>
  <div>
    <div v-html="apply" v-if="apply"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      apply: "",
    };
  },
  created() {
    let form = localStorage.getItem("alipayForm");
    this.apply = form;
  },
  mounted() {
   
    let form = localStorage.getItem("alipayForm");
    this.apply = form;
    setTimeout(() => {
      document.forms[0].submit();
    }, 100);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
